export default __webpack_public_path__ + "static/media/38_desktop.76ef8ade.jpeg";